export default __webpack_public_path__ + "static/media/nissan.8e49b59c.svg";